import * as React from "react";

import {Formik, Form} from "formik";
import {useDispatch} from "react-redux";
import {unwrapResult} from "@reduxjs/toolkit";

import {useHistory, Link} from "react-router-dom";
import {toast} from "react-toastify";

import * as Yup from "yup";

import Field from "../../components/Field";
import {forgotPassword} from "./ducks/authSlice";

import {useBodyClass} from "../../theme/utils";

const initialValues = {
    email: "",
    otp: "",
};

const validationSchema = Yup.object().shape({
    email: Yup.string().required(),
    otp: Yup.string().optional(),
});

export default function ForgotPasswordForm(props) {
    const dispatch = useDispatch();
    const history = useHistory();

    const [notifications, setNotifications] = React.useState([]);

    useBodyClass("gray-bg");

    const handleSubmit = async (values, {setErrors, resetForm}) => {
        const resultAction = await dispatch(forgotPassword(values));
        if (forgotPassword.fulfilled.match(resultAction)) {
            setNotifications([
                ...notifications,
                "We send you and email with a reset link to change your password.",
            ]);
            resetForm();
            setTimeout(() => {
                history.push(`/login`);
            }, 10000);
        } else {
            if (resultAction.payload) {
                setErrors(resultAction.payload.field_errors);
            }
        }
    };

    return (
        <div className="container-fluid">
            <div style={{margin: "0 auto", padding: "100px 10px 10px 10px"}}>
                {notifications.length > 0 && (
                    <div className="row justify-content-center">
                        <div className="col-md-4 col-sm-12 bg-primary p-xs">
                            {notifications.map((n) => (
                                <span>{n}<br/></span>
                            ))}
                        </div>
                    </div>
                )}
                <div className="row justify-content-center">
                    <div className="col-md-4 col-sm-12 p-sm bg-white">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            validateOnChange={false}
                            validateOnBlur={false}
                            validateOnMount={false}
                            onSubmit={handleSubmit}
                            render={({errors}) => (
                                <Form>
                                    {/*We use error.otp because we want to not showe the reason for error */}
                                    <Field
                                        error={errors.otp}
                                        htmlFor="email"
                                        placeholder="Your email address"
                                    />
                                    {/*<Field error={errors.otp} htmlFor="otp" placeholder="Token"/>*/}
                                    <button
                                        className="btn btn-warning block full-width m-b"
                                        type="submit"
                                    >
                                        <i className="fa fa-sign-in"/> Reset Password
                                    </button>

                                    <div className="btn-group btn-block">
                                        <a
                                            href="/login"
                                            className="btn btn-sm btn-white "
                                        >
                                            Go back
                                        </a>
                                    </div>
                                </Form>
                            )}
                        />
                    </div>
                </div>
                <div className="row justify-content-center m-t-md">
                    <div className="col-md-4 col-sm-12 border-top">
                        <div className="row m-t-sm">
                            <div className="col text-left">
                                <small>ConDevTec GmbH</small>
                            </div>
                            <div className="col text-center">
                                <small>Made with <i className="fa fa-heart" style={{color: "#d40e0e"}}/> in
                                    Munich</small>
                            </div>
                            <div className="col text-right">
                                <small>&copy; 2018 - {new Date().getFullYear()}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
